exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n    1.主色调，整体项目的主要颜色。\n    2.首页的背景颜色。\n    3.字体颜色。主要是和主色调来配合使用。\n    4.表格滑过的颜色。\n    5.表格选中的颜色。\n    6/7.首页每一项渐变的颜色，待定。\n*/\n", ""]);

// exports
